export default __webpack_public_path__ + "static/media/modern-components-light.00b61f69.png";